import PortalMenuEdit from './Edit'
import PortalMenuLists from './List'

const portalMenusResource = {
  list: PortalMenuLists,
  edit: PortalMenuEdit,
}

export default portalMenusResource
